'use strict';

module.exports = {
    getUrl() {
        return Odigeo.Settings.getProperty('bookingApiUrlFormatter')('updateBooking');
    },

    getMethod: Odigeo._.constant('POST'),

    formatUpdateBookingRequest(membershipId, updateBookingRequest) {
        return {
            createBookingProductCategoryList: [
                {
                    productCategoryFees: [
                        {
                            amount: updateBookingRequest.amount,
                            currency: updateBookingRequest.currency,
                        },
                    ],
                    productCategoryBookingItemType: 'MEMBERSHIP_SUBSCRIPTION',
                    createProviderBookingList: [
                        {
                            typeInfo: 'CreateOtherProductProviderBooking',
                            status: 'CONTRACT',
                            totalProviderPrice: {
                                amount: updateBookingRequest.amount,
                                currency: updateBookingRequest.currency,
                            },
                            createProviderPaymentDetailRequests: [
                                {
                                    typeInfo: 'createProviderPaymentDetailRequest',
                                    paymentType: 'CASH',
                                    amount: updateBookingRequest.amount,
                                    currency: updateBookingRequest.currency,
                                    merchant: false,
                                },
                            ],
                            productId: membershipId,
                        },
                    ],
                },
            ],
        };
    },
};
